// @flow
function isLoggedInCust(session, userInfo) {
    console.log({ userInfo, session });
    return userInfo.length === 1 && userInfo[0].custUrl === session.custUrl;
}

export { isLoggedInCust };



// WEBPACK FOOTER //
// ./src/utils/session.js